<template>
  <div class="content" v-if="!loading && shoppers">
    <div class="lineBox" style="padding-top:10px; border:0px;"> 
      <span class="h3" style="float:let;margin-top:5px;">Shoppers</span>
      <button style="float:right;" @click="openModalShopper()">Novo Shopper</button><br/>
    </div>

    <div class="line"> 
      <div style="padding:10px; ">
        <table border="1" cellpadding="5px" style="min-width:700px; border-collapse:collapse; border:1px solid #706C7A;width:100%">
          <thead> 
            <tr> 
              <td style="text-align:center;">Nome</td>
              <td style="text-align:center;">Documento Identidade</td>
              <td style="text-align:center;">Email</td>
              <td style="text-align:center;">Telefone</td>
              <td style="text-align:center;">Ações</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(shopper,idx) in shoppers" v-bind:key="idx">
              <td>{{shopper.name}}</td>
              <td>{{shopper.document_number}}</td>
              <td>{{shopper.email}}</td>
              <td>{{shopper.phone}}</td>
              <td style="text-align:center;">
                <a @click="removeShopper(shopper)">
                  <font-awesome-icon style="font-size:18px;color:#FF0000;margin:5px;" :icon="['fal', 'trash']"/>
                </a>
              </td> 
            </tr>  
          </tbody>
        </table>
      </div>
    </div>
    <OpaModal v-if="tempShopper" width="900" height="440" v-model="modalShopper" header="Shopper">
      <div style="height:280px;overflow:auto; padding:20px;width:100%">
        <div style="width:calc(50% - 20px);padding:10px;float:left;">
          Nome:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:20px;" v-model="tempShopper.name" />
          <br/>
          Documento Identidade:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:20px;" v-model="tempShopper.document_number"/>
          <br/>
          Senha:<br/>
          <input type="text" class="inputWire" style="border-color:#ffffff;width:360px;margin-bottom:20px;" v-model="tempShopper.password" />
          
          <br/>
        </div>
        <div style="width:calc(50% - 60px);padding:10px;float:left;position:relative;">
          Email:<br/>
          <input type="text" class="inputWire" style="border-color: #ffffff;width:360px;margin-bottom:20px;" v-model="tempShopper.email" />
          <br/>Telefone:<br/>
          <input type="text" class="inputWire" style="border-color: #ffffff;width:360px;margin-bottom:20px;" v-model="tempShopper.phone" />
        </div>
      </div>
      <div class="modal_footer">
        <button style="width:80px;float:right;margin:20px;" @click="saveShopper()">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px" @click="cancelEditShopper()">Cancelar</button>
      </div>
    </OpaModal>
  </div>
</template>

<script>
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import ShopperConn from '@/connection/shopper'    
import formater from '@/mixins/formater'


export default {
  name: 'Shoppers',
  data () {
    return {
      shoppers: null,
      loading: true,
      tempShopper: null,
      modalShopper: false
    }
  },

  mixins: [formater],

  components: {OpaModal},

  created () {
    if (this.loading) {
      EventBus.$emit('showLoading', true)
    }
    this.resetTempShopper()
    this.loadShoppers()
  },

  methods: {

    async loadShoppers () {
      let result = await ShopperConn.getShoppers ()
      if (result.error) {
        this.shoppers = []
        EventBus.$emit('showAlert', 'error', result.msg)
    
      } else {
        result.sort((a,b) => b.order - a.order)
        this.shoppers = result
      }
      this.loading = false
      EventBus.$emit('showLoading', false)
    },

    resetTempShopper () {
      this.tempShopper = {
        name: null, 
        document_number: null,
        password: null,
        email: null, 
        phone: null
      }
    },

    openModalShopper () {
      this.resetTempShopper()
      this.modalShopper = true
    },

    cancelEditShopper () {
      this.resetTempShopper()
      this.modalShopper=false
    },

    async saveShopper () {
      if (this.validShopper()) {
        EventBus.$emit('showLoading', true)
        let result = await ShopperConn.saveShopper(this.tempShopper)
        EventBus.$emit('showLoading', false)
        if (!result.error) {
          this.resetTempShopper()
          this.modalShopper = false
          this.loadShoppers()
          this.modalShopper=false
        } else {
          EventBus.$emit('showAlert', 'error', result.msg)
        }
      }
      
    },
    validShopper () {
      if (!this.tempShopper.name || this.tempShopper.name.lenght < 3 ) {
        EventBus.$emit('showAlert', 'error', 'nome é obrigatório')
        return false
      }
      if (!this.tempShopper.document_number || this.tempShopper.document_number.lenght < 2 ) {
        EventBus.$emit('showAlert', 'error', 'documento de identificação é obrigatório')
        return false
      }
      if (!this.tempShopper.password || this.tempShopper.password.lenght < 1 ) {
        EventBus.$emit('showAlert', 'error', 'password é obrigatório')
        return false
      }
      if (!this.tempShopper.email || this.tempShopper.email.lenght < 3) {
        EventBus.$emit('showAlert', 'error', 'email é obrigatório')
        return false 
      }
      if (!this.tempShopper.phone || this.tempShopper.phone.lenght < 3) {
        EventBus.$emit('showAlert', 'error', 'phone é obrigatório')
        return false
      }
      return true
    },

    async removeShopper (shopper) {
      if (confirm('Deseja realmente excluir  o shopper?')){
        EventBus.$emit('showLoading', true)
        let result = await ShopperConn.deleteShopper(shopper.email)
        if (!result.error) {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'success', 'Shopper removido com sucesso')
          this.loadShoppers()
        } else {
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'Erro ao remover shopper')
        }
      }
    }
  },

  
}
</script>

<style>
a {
  cursor:pointer;
}
</style>
